import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { catchError, throwError } from 'rxjs';

function formatApiError(err: HttpErrorResponse): string {
  const body = err.error;
  if (body && typeof body === 'object') {
    const errors = (body as { errors?: string[] }).errors;
    if (Array.isArray(errors) && errors.length) {
      return errors.join(' ');
    }
    const msg = (body as { message?: string }).message;
    if (typeof msg === 'string' && msg) return msg;
  }
  if (err.status === 0) return 'Network error. Please check your internet connection.';
  if (err.status === 403) return 'Access denied.';
  if (err.status === 409) return 'Conflict occurred. Please try again.';
  return err.message || `HTTP ${err.status}`;
}

export const apiErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const messages = inject(MessageService);

  if (req.headers.get('X-Skip-Error-Toast')) {
    return next(req);
  }

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      const u = req.url.toLowerCase();

      // 401 errors are always handled by the auth interceptor (refresh + retry or logout).
      // Showing a toast here would be redundant or confusing.
      if (err.status === 401) {
        return throwError(() => err);
      }

      // Auth endpoints handle their own error display (login forms, etc.)
      if (
        u.includes('/auth/login') ||
        u.includes('/auth/register') ||
        u.includes('/auth/forgot-password') ||
        u.includes('/auth/reset-password')
      ) {
        return throwError(() => err);
      }

      const summary = formatApiError(err);
      messages.add({
        severity: 'error',
        summary,
        life: 6000,
      });
      return throwError(() => err);
    }),
  );
};
